import { io } from "socket.io-client";
import { SocketUrl } from "./http";
const socket = io(SocketUrl, { autoConnect: true });

socket.connect();

export default socket;
